import React, { useState, useRef, useEffect } from "react"
import { Grid } from "unsemantic/assets/react/dist/index"
import JSONDep from "../../Json/Departamentos.json"
import JSONPro from "../../Json/Provincias.json"
import JSONDis from "../../Json/Distritos.json"
import { navigate, Link } from "gatsby"
import Button from "../atoms/Button/Button"

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1)
  var sURLVariables = sPageURL.split("&")
  var sParameterName
  var i
  for (i = 0;i < sURLVariables.length;i++) {
    sParameterName = sURLVariables[i].split("=")

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1])
    }
  }
}

// Lima (departamento) -> Lima (provincia), fijos porque todos los
// proyectos de Pionero están en Lima Metropolitana.
const ID_UBIGEO_DEPARTAMENTO_LIMA = "3926"
const ID_UBIGEO_PROVINCIA_LIMA = "3927"

const normalizarTexto = texto =>
  (texto || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[áàäâ]/g, "a")
    .replace(/[éèëê]/g, "e")
    .replace(/[íìïî]/g, "i")
    .replace(/[óòöô]/g, "o")
    .replace(/[úùüû]/g, "u")
    .replace(/ñ/g, "n")

const FormCotizarSperant = ({
  urlWsp,
  tipoDepa,
  nomProyecto,
  urlGracias,
  codInmueble,
  correoCotiza,
  numDorm,
  projectId,
  projectSlug,
  typologyId,
  crmTypologyId,
  bathrooms,
  distritoProyecto,
}) => {
  const [nombre, setNombre] = useState("")
  const [apellidos, setApellidos] = useState("")
  const [telefono, setTelefono] = useState("")
  const [email, setEmail] = useState("")
  const [dni, setDni] = useState("")
  const [idDepartamento, setIdDepartamento] = useState("")
  const [nomDepartamento, setNomDepartamento] = useState("")
  const [nomProvincia, setNomProvincia] = useState("")
  const [idProvincia, setIdProvincia] = useState("")
  const [provincias, setProvincias] = useState([])
  const [nomDistrito, setNomDistrito] = useState("")
  const [distritos, setDistritos] = useState("")
  const [idDistrito, setIdDistrito] = useState("")
  const [distritoAutoCompletado, setDistritoAutoCompletado] = useState(false)
  const [envio, setEnvio] = useState("")
  const [aceptar, setAceptar] = useState("")

  const [validNombres, setValidNombres] = useState("")
  const [validApellidos, setValidApellidos] = useState("")
  const [validTelefono, setValidTelefono] = useState("")
  const [validEmail, setValidEmail] = useState("")
  const [validDni, setValidDni] = useState("")
  const [validIdDepartamento, setValidIdDepartamento] = useState("")
  const [validIdProvincia, setValidIdProvincia] = useState("")
  const [validIdDistrito, setValidIdDistrito] = useState("")
  const [validAceptar, setValidAceptar] = useState("")

  let hpionero = useRef(null)
  let hpionero2 = useRef(null)
  let whatsapp = useRef(null)
  const btnSubmitRef = useRef(null)

  let utm_source = ""
  let utm_medium = ""
  let utm_campaign = ""
  let utm_term = ""
  let utm_content = ""

  utm_campaign = getUrlParameter("utm_campaign")
  utm_content = getUrlParameter("utm_content")
  utm_medium = getUrlParameter("utm_medium")
  utm_source = getUrlParameter("utm_source") || "organic" // Por defecto "organic"
  utm_term = getUrlParameter("utm_term")

  // Autocompleta Departamento/Provincia/Distrito con el distrito real del
  // proyecto, para no pedirle al usuario que elija algo que ya sabemos.
  // Si no encontramos el distrito en el listado, dejamos los campos
  // visibles para que lo complete a mano.
  useEffect(() => {
    if (!distritoProyecto) return

    const distritosLima = JSONDis[0][ID_UBIGEO_PROVINCIA_LIMA] || []
    const match = distritosLima.find(
      d => normalizarTexto(d.nombre_ubigeo) === normalizarTexto(distritoProyecto)
    )

    if (!match) {
      console.warn(
        `FormCotizarSperant: no se encontró el distrito "${distritoProyecto}" en el listado de Lima.`
      )
      return
    }

    setIdDepartamento(ID_UBIGEO_DEPARTAMENTO_LIMA)
    setNomDepartamento("Lima")
    setProvincias(
      (JSONPro[0][ID_UBIGEO_DEPARTAMENTO_LIMA] || []).map((ele, i) => (
        <option key={i} value={ele.id_ubigeo}>
          {ele.nombre_ubigeo}
        </option>
      ))
    )
    setIdProvincia(ID_UBIGEO_PROVINCIA_LIMA)
    setNomProvincia("Lima")
    setDistritos(
      distritosLima.map((ele, i) => (
        <option key={i} value={ele.id_ubigeo}>
          {ele.nombre_ubigeo}
        </option>
      ))
    )
    setIdDistrito(match.id_ubigeo)
    setNomDistrito(match.nombre_ubigeo)
    setDistritoAutoCompletado(true)
  }, [distritoProyecto])

  const handleSubmit = async event => {
    event.preventDefault()

    let errores = 0

    if (nombre === "") {
      setValidNombres(true)
      errores++
    } else setValidNombres(false)
    if (apellidos === "") {
      setValidApellidos(true)
      errores++
    } else setValidApellidos(false)
    if (telefono === "") {
      setValidTelefono(true)
      errores++
    } else setValidTelefono(false)
    if (
      email === "" ||
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)
    ) {
      setValidEmail(true)
      errores++
    } else setValidEmail(false)
    if (dni === "" || !/^\d{8}$/.test(dni)) {
      setValidDni(true)
      errores++
    } else setValidDni(false)
    if (idDepartamento === "") {
      setValidIdDepartamento(true)
      errores++
    } else setValidIdDepartamento(false)
    if (idProvincia === "") {
      setValidIdProvincia(true)
      errores++
    } else setValidIdProvincia(false)
    if (idDistrito === "") {
      setValidIdDistrito(true)
      errores++
    } else setValidIdDistrito(false)
    if (aceptar === "" || aceptar === false) {
      setValidAceptar(true)
      errores++
    } else setValidAceptar(false)
    if (hpionero.current.value !== "") errores++
    if (hpionero2.current.value !== "apros") errores++
    if (hpionero.current.value !== "" || hpionero2.current.value !== "apros")
      setEnvio(true)

    if (errores === 0) {
      if (codInmueble === undefined) codInmueble = ""
      if (utm_campaign === undefined) utm_campaign = ""
      if (utm_content === undefined) utm_content = ""
      if (utm_medium === undefined) utm_medium = ""
      if (utm_source === undefined) utm_source = ""
      if (utm_term === undefined) utm_term = ""

      const whatsappValue = whatsapp.current.value

      const dataPost = {
        projectId: projectId || null,
        projectSlug: projectSlug || "",

        typologyId: typologyId || null,
        typologyCode: codInmueble || "",
        typologyName: tipoDepa || "",
        crmTypologyId: crmTypologyId || "",

        bedrooms: Number(numDorm || 0),
        bathrooms: Number(bathrooms || 0),

        name: nombre,
        lastname: apellidos,
        email: email,
        phone: telefono,
        dni: dni,

        department: nomDepartamento,
        province: nomProvincia,
        district: nomDistrito,

        acceptedPrivacy: aceptar === true,
        whatsapp: whatsappValue === "1",

        pageUrl: typeof window !== "undefined" ? window.location.href : "",

        utm: {
          source: utm_source || "organic",
          medium: utm_medium || "",
          campaign: utm_campaign || "",
          content: utm_content || "",
          term: utm_term || "",
        },

        honeypot: hpionero.current.value || "",
      }

      try {
        const rpta = await fetch(
          `${process.env.GATSBY_PAGINA_COMPILADOR}/wp-json/pionero/v1/leads`,
          {
            method: "POST",
            body: JSON.stringify(dataPost),
            headers: { "Content-Type": "application/json" },
          }
        )

        const data = await rpta.json()

        if (rpta.ok && data.success) {
          if (whatsappValue === "1") {
            if (urlWsp) window.open(urlWsp, "_blank")
          }
          setEnvio(true)
          navigate(urlGracias || data.thankYouUrl)
        } else {
          console.error("Error en el envío de lead:", data)
          setEnvio(false)
        }
      } catch (error) {
        console.error("Error al conectar con el endpoint de leads:", error)
        setEnvio(false)
      }
    } else {
      whatsapp.current.value = 1
    }
  }

  const handleDep = event => {
    setIdDepartamento(event.target.value)
    if (event.target.value !== "") {
      let index = event.target.selectedIndex
      setNomDepartamento(event.target.options[index].text)
      const pro = JSONPro[0][event.target.value].map((ele, i) => {
        return (
          <option key={i} value={ele.id_ubigeo}>
            {ele.nombre_ubigeo}
          </option>
        )
      })
      setProvincias(pro)
    } else {
      setProvincias("")
      setNomDepartamento("")
      setNomProvincia("")
      setDistritos("")
      setNomDistrito("")
    }
  }
  const handleProv = event => {
    setIdProvincia(event.target.value)
    if (event.target.value !== "") {
      let index = event.target.selectedIndex
      setNomProvincia(event.target.options[index].text)
      const dis = JSONDis[0][event.target.value].map((ele, i) => {
        return (
          <option key={i} value={ele.id_ubigeo}>
            {ele.nombre_ubigeo}
          </option>
        )
      })
      setDistritos(dis)
    } else {
      setNomProvincia("")
      setNomDistrito("")
      setDistritos("")
    }
  }
  const handleDis = event => {
    setIdDistrito(event.target.value)
    if (event.target.value !== "") {
      let index = event.target.selectedIndex
      setNomDistrito(event.target.options[index].text)
    } else {
      setNomDistrito("")
    }
  }

  const handleWhatsapp = () => {
    whatsapp.current.value = "1"
    btnSubmitRef.current.click()
  }

  return (
    <div className="form-cotizar">
      <h2 className="form-cotizar-titulo font-roboto weight-300">
        Ingrese sus Datos
      </h2>

      <form onSubmit={handleSubmit} encType="multipart/form-data" noValidate>
        <Grid desktop="100" tablet="100" mobile="100">
          <Grid desktop="100" tablet="100" mobile="100">
            <div className="form-control">
              <input type="hidden" name="_wpcf7" value="835" />
              <input type="hidden" name="proyecto" value={nomProyecto} />
              <input type="hidden" name="tipo-departamento" value={tipoDepa} />
              <input type="hidden" name="cod-inmueble" value={codInmueble} />
              <input type="hidden" name="utm_campaign" value={utm_campaign} />
              <input type="hidden" name="utm_content" value={utm_content} />
              <input type="hidden" name="utm_medium" value={utm_medium} />
              <input type="hidden" name="utm_source" value={utm_source} />
              <input type="hidden" name="utm_term" value={utm_term} />
              <input type="hidden" name="whatsapp" value="" ref={whatsapp} />
              <input
                type="text"
                value={tipoDepa}
                placeholder="Tipo de Departamento"
                disabled
              />
            </div>
          </Grid>
          <Grid desktop="100" tablet="100" mobile="100">
            <div className="form-control">
              <input
                type="text"
                value={nombre}
                onChange={e => setNombre(e.target.value)}
                name="nombre"
                placeholder="Nombre"
              />
              {validNombres && (
                <span className="size-17 color-rojo">
                  El campo es obligatorio.
                </span>
              )}
            </div>
          </Grid>
          <Grid desktop="100" tablet="100" mobile="100">
            <div className="form-control">
              <input
                type="text"
                value={apellidos}
                onChange={e => setApellidos(e.target.value)}
                name="apellidos"
                placeholder="Apellidos"
              />
              {validApellidos && (
                <span className="size-17 color-rojo">
                  El campo es obligatorio.
                </span>
              )}
            </div>
          </Grid>
          <Grid desktop="100" tablet="100" mobile="100">
            <div className="form-control">
              <input
                type="tel"
                value={telefono}
                onChange={e => setTelefono(e.target.value)}
                name="telefono"
                placeholder="Teléfono"
              />
              {validTelefono && (
                <span className="size-17 color-rojo">
                  El campo es obligatorio.
                </span>
              )}
            </div>
          </Grid>
          <Grid desktop="100" tablet="100" mobile="100">
            <div className="form-control">
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                name="email"
                placeholder="Email"
              />
              <input
                type="hidden"
                name="departamento"
                value={nomDepartamento}
              />
              <input type="hidden" name="provincia" value={nomProvincia} />
              <input type="hidden" name="distrito" value={nomDistrito} />
              {validEmail && (
                <span className="size-17 color-rojo">
                  El campo es obligatorio.
                </span>
              )}
            </div>
          </Grid>
          <Grid desktop="100" tablet="100" mobile="100">
            <div className="form-control">
              <input
                type="text"
                inputMode="numeric"
                maxLength="8"
                value={dni}
                onChange={e => setDni(e.target.value.replace(/\D/g, ""))}
                name="dni"
                placeholder="DNI"
              />
              {validDni && (
                <span className="size-17 color-rojo">
                  Ingrese un DNI válido (8 dígitos).
                </span>
              )}
            </div>
          </Grid>
          {!distritoAutoCompletado && (
            <>
              <Grid desktop="33" tablet="33" mobile="100">
                <div className="form-control">
                  <label>
                    <span className="form-control-texto">Departamento</span>
                    <select
                      name="id_departamento"
                      value={idDepartamento}
                      onChange={handleDep}
                      onBlur={handleDep}
                    >
                      <option value="">Seleccionar</option>
                      {JSONDep &&
                        JSONDep.map((dep, i) => (
                          <option key={i} value={dep.id_ubigeo}>
                            {dep.nombre_ubigeo}
                          </option>
                        ))}
                    </select>
                    {validIdDepartamento && (
                      <span className="size-17 color-rojo">
                        El campo es obligatorio.
                      </span>
                    )}
                  </label>
                </div>
              </Grid>
              <Grid desktop="33" tablet="33" mobile="100">
                <div className="form-control">
                  <label>
                    <span className="form-control-texto">Provincia</span>
                    <select
                      name="id_provincia"
                      value={idProvincia}
                      onChange={handleProv}
                      onBlur={handleProv}
                    >
                      <option value="">Seleccionar</option>
                      {provincias}
                    </select>
                    {validIdProvincia && (
                      <span className="size-17 color-rojo">
                        El campo es obligatorio.
                      </span>
                    )}
                  </label>
                </div>
              </Grid>
              <Grid desktop="33" tablet="33" mobile="100">
                <div className="form-control">
                  <label>
                    <span className="form-control-texto">Distrito</span>
                    <select
                      name="id_distrito"
                      value={idDistrito}
                      onChange={handleDis}
                      onBlur={handleDis}
                    >
                      <option value="">Seleccionar</option>
                      {distritos}
                    </select>
                    {validIdDistrito && (
                      <span className="size-17 color-rojo">
                        El campo es obligatorio.
                      </span>
                    )}
                  </label>
                </div>
              </Grid>
            </>
          )}
          <Grid desktop="100" tablet="100" mobile="100">
            <div className="form-control">
              <input
                type="text"
                name="hpionero"
                className="none"
                defaultValue=""
                ref={hpionero}
              />
              <input
                type="text"
                name="hpionero2"
                defaultValue="apros"
                style={{ display: "none" }}
                ref={hpionero2}
              />
              <label className="form-aceptar">
                <input type="checkbox" onChange={e => setAceptar(!aceptar)} />
                <span>
                  He leído y acepto todos los{" "}
                  <Link
                    to="/terminos-y-condiciones/"
                    className="color-negro weight-bold"
                    target="_blank"
                    rel="noreferrer"
                  >
                    términos y condiciones
                  </Link>
                  , y la{" "}
                  <Link
                    to="/politica-privacidad/"
                    className="color-negro weight-bold"
                    target="_blank"
                    rel="noreferrer"
                  >
                    política de privacidad
                  </Link>{" "}
                  del Grupo Pionero Inmobiliaria
                </span>
              </label>
              {validAceptar && (
                <span className="size-17 color-rojo">
                  El campo es obligatorio.
                </span>
              )}
            </div>
          </Grid>
          <Grid desktop="100" tablet="100" mobile="100">
            <div className="group-form-buttons text-center">
              <Button
                size="small"
                refEle={btnSubmitRef}
                type="submit"
                classEle="font-roboto bg-negro color-pagina"
                disabled={envio}
              >
                ENVIAR COTIZACIÓN
              </Button>
            </div>
            {envio === false && envio !== "" && (
              <div className="font-roboto line-heihgt-normal">
                Error en el envio
              </div>
            )}
          </Grid>
        </Grid>
      </form>
    </div>
  )
}

export default FormCotizarSperant
